function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// semeia-disable-reexport

import { numberTriesForLastHourPerCpsId, numberTriesForLastTwentyFourHoursPerCpsId } from "cnam/utils/dmp-utils";
export class DmpAdapter {
  constructor(medic) {
    _defineProperty(this, "LIMIT_PER_HOUR", 30);
    _defineProperty(this, "UPPER_LIMIT_PER_HOUR", 80);
    _defineProperty(this, "LIMIT_PER_DAY", 200);
    this.medic = medic;
    this.currentLimitPerHour = medic?.canUseDmpRetrievalUpperLimit ? this.UPPER_LIMIT_PER_HOUR : this.LIMIT_PER_HOUR;
  }
  // abstract observeCard: TaskForAsyncTaskFunction<
  //   unknown,
  //   (onCardNotAvailable: () => void) => Promise<void>
  // >;

  get currentHourlyRate() {
    const jes = this.store.peekAll("dmp-retrieval-started-journal-event");
    return this.authenticationContext?.cpsInformations ? numberTriesForLastHourPerCpsId(jes, this.authenticationContext.cpsInformations?.medicInternalId) : 0;
  }
  get currentDailyRate() {
    const jes = this.store.peekAll("dmp-retrieval-started-journal-event");
    return this.authenticationContext?.cpsInformations ? numberTriesForLastTwentyFourHoursPerCpsId(jes, this.authenticationContext.cpsInformations?.medicInternalId) : 0;
  }
  get hourlyRateExceeded() {
    return this.currentHourlyRate >= this.currentLimitPerHour;
  }
  get dailyRateExceeded() {
    return this.currentDailyRate >= this.LIMIT_PER_DAY;
  }
  get hourlyRemainingRate() {
    return this.currentLimitPerHour - this.currentHourlyRate;
  }
  get dailyRemainingRate() {
    return this.LIMIT_PER_DAY - this.currentDailyRate;
  }
  get remainingRate() {
    return Math.min(this.hourlyRemainingRate, this.dailyRemainingRate);
  }
}